"use strict";

// Components
import FilterCatgs from './components/filtercatgs';
import TabsUnits from './components/tabs-units';
import TabsProducts from './components/tabs-products';
import Header from './components/header';
import SectionContentWithVideo from './components/section-content-with-video';
import SectionBlockListNews from './components/section-block-list-news';
import ModalVideo from './components/video-modal';
import Comments from './components/ajax-comment';
import Forms from './components/forms';

// Pages
import CalcSelantesAdesivos from './pages/calc-selantes-adesivos';
import CalcChumbadoresQuimicos from './pages/calc-chumbadores-quimicos';
import CalcRejuntes from './pages/calc-rejuntes';
import History from './pages/history';
import Home from './pages/home';
import ProductSingle from './pages/products-single';
import Blog from './pages/blog';
import Lojas from './pages/lojas';
import AutocompleteAddress from './components/autocomplete-addr';

export default class App {
    constructor(){
        //Components
        const FilterCatgsComponent = document.querySelector('.filter_categs');
        const TabsUnitsComponent = document.querySelector('.tabs-units');
        const TabsProductsComponent = document.querySelector('.tabs-products');
        const HeaderComponent = document.querySelector('.headerjs');
        const SectionContentWithVideoComponent = document.querySelector('.section-content-with-video');
        const SectionBlockListNewsComponent = document.querySelector('.filter-categs-blog');
        const ModalVideoComponent = document.querySelector('.modal-video-id');
        const CommentsComponent = document.querySelector('.comments-area');
        const FormsComponent = document.querySelector('.form-contact');
        const AutocompleteAddressComponent = document.querySelector('input[name="search_address"]');

        //Pages
        const CalcSelantesAdesivosComponent = document.querySelector('.calc-selantes-adesivos');
        const CalcChumbadoresQuimicosComponent = document.querySelector('.calc-chumbadores-quimicos');
        const CalcRejuntesComponent = document.querySelector('.calc-rejuntes');
        const HistoryComponent = document.querySelector('.sliders-our-history');
        const HomeComponent = document.querySelector('.slider');
        const ProductSingleComponent = document.querySelector('.product-single');
        const BlogComponent = document.querySelector('.posts');
        const LojasComponent = document.querySelector('.contact-stores');

        //Utils
        const MaskComponent = document.querySelector('.posts');
        
        //Load component if necessary
        FilterCatgsComponent ? new FilterCatgs() : null;
        TabsUnitsComponent ? new TabsUnits() : null;
        TabsProductsComponent ? new TabsProducts() : null;
        HeaderComponent ? new Header() : null;
        SectionContentWithVideoComponent ? new SectionContentWithVideo() : null;
        SectionBlockListNewsComponent ? new SectionBlockListNews() : null;
        ModalVideoComponent ? new ModalVideo() : null;
        SectionContentWithVideoComponent ? new SectionContentWithVideo() : null;
        
        CalcSelantesAdesivosComponent ? new CalcSelantesAdesivos() : null;
        CalcChumbadoresQuimicosComponent ? new CalcChumbadoresQuimicos() : null;
        CalcRejuntesComponent ? new CalcRejuntes() : null;
        HistoryComponent ? new History() : null;
        HomeComponent ? new Home() : null;
        ProductSingleComponent ? new ProductSingle() : null;
        BlogComponent ? new Blog() : null;
        CommentsComponent ? new Comments() : null;
        FormsComponent ? new Forms() : null;
        LojasComponent ? new Lojas() : null;
        AutocompleteAddressComponent ? new AutocompleteAddress() : null;
    }
}

new App();
